import React from 'react'
import { Box, Button } from '@mui/material'

const MultiLogin = ({ handleSubmit,handleCancel }) => {
  return (
    <Box>
      <p className="text-sm leading-normal font-family-georgia">
        It appears that there is an active login session for this user. Would
        you like to terminate the existing session and proceed?
      </p>
      <Box className="pt-5 flex gap-2 justify-end">
        <Button
          variant="contained"
          color="success"
          sx={{ bgcolor: '#e91e63' }}
          onClick={handleSubmit}
        >
          Yes
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={handleCancel}
        >
          No
        </Button>
      </Box>
    </Box>
  )
}

export default MultiLogin
